module.exports = __webpack_public_path__ + "img/breadcrumb2.fa465193.svg";